module.exports = __webpack_public_path__ + "static/media/34_A.8fe81429.png";